import { GET_NEWS_LOADING, GET_NEWS_SUCCESS, GET_ANNOUNCEMENTS_ERROR, GET_NEWS_ERROR } from "../../../constant/actionTypes";

const newsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_NEWS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_NEWS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case GET_NEWS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default newsReducer;